import fetchClient from "@/utils/fetchClient"

export default {
  state: {
    sparePartsList: [], //data for spareparts search tool
    loadingSparePartsList: false, //show that the search is ongoing
    errorMessage: ""
  },
  mutations: {
    updateSparePartsList(state, payload) {
      state.sparePartsList = payload
    },
    setLoadingSparePartsList(state, payload) {
      state.loadingSparePartsList = payload
    },
    updateErrorMessage(state, payload) {
      state.errorMessage = payload
    }
  },
  actions: {
    async clearErrorMessage(context) {
      return new Promise(resolve => {
        context.commit("updateErrorMessage", "")
        resolve("")
      })
    },
    async clearSparePartsList(context) {
      return new Promise(resolve => {
        context.commit("updateSparePartsList", {})
        resolve({})
      })
    },
    fetchSparePartsProdIdRev(context, { params }) {
      context.commit("setLoadingSparePartsList", true)

      fetchClient()
        .get(
          `/api/v1/spareparts/productid/revision?productId=${params.prodId}&revision=${params.rev}`
        )
        .then(data => {
          context.commit("updateSparePartsList", data)
        })
        .catch(error => {
          context.commit("updateErrorMessage", error.message)
        })
        .finally(() => {
          context.commit("setLoadingSparePartsList", false)
        })
    },
    fetchSparePartsProdId(context, { params }) {
      context.commit("setLoadingSparePartsList", true)

      fetchClient()
        .get(`/api/v1/spareparts/productid?productId=${params.prodId}`)
        .then(data => {
          context.commit("updateSparePartsList", data)
        })
        .catch(error => {
          context.commit("updateErrorMessage", error.message)
        })
        .finally(() => {
          context.commit("setLoadingSparePartsList", false)
        })
    },
    fetchSparePartsSerialNo(context, { params }) {
      context.commit("setLoadingSparePartsList", true)

      fetchClient()
        .get(`/api/v1/spareparts/serialNo?serialNo=${params.serialNo}`)
        .then(data => {
          context.commit("updateSparePartsList", data)
        })
        .catch(error => {
          context.commit("updateErrorMessage", error.message)
        })
        .finally(() => {
          context.commit("setLoadingSparePartsList", false)
        })
    },
    fetchSparePartsTools(context, { params }) {
      context.commit("setLoadingSparePartsList", true)

      fetchClient()
        .get(`/api/v1/spareparts/tools?tools=${params.revision}`)
        .then(data => {
          context.commit("updateSparePartsList", data)
        })
        .catch(error => {
          context.commit("updateErrorMessage", error.message)
        })
        .finally(() => {
          context.commit("setLoadingSparePartsList", false)
        })
    }
  },
  getters: {
    spareParts: state => {
      return state.spareParts
    },
    sparePartsList: state => {
      return state.sparePartsList
    },
    sparePartsSearchLoading: state => {
      return state.loadingSparePartsList
    },
    errorMessage: state => {
      return state.errorMessage
    }
  }
}
